<template>
  <div class="min-h-80 p-2 bg-gray-200 dark:bg-gray-900">
    <addModal @refresh="getAll" />
    <editModal @refresh="getAll" :row="selected" />
    <addAccountModal @refresh="getAll" :customer="selected" />
    <viewAccountsModal :customer="selected" />
    <div class="h-full p-2 bg-gray-50 dark:bg-gray-800 rounded shadow-sm">
      <div class="w-full">
          <LyrausTable
            :data="List"
            :columns="columns"
            :enablePagination="true"
            :isLoading="load"
            :batchOperations="true"
            :searchBar="true"
            :searchProp="search"
            @update-search-value="(val) => handleSearchValue(val)"
            :handleSearch="handleSearch"
            :pageCount="pageCount"
            :pageProp="currentPage"
            @update-current-page="handleCurrentPage"
            :totalCount="totalCount"
            :alternateRowBg="['white', 'gray-100']"
            :rightExtraSlot="true"
            :buttonsColumn="{ label: 'İşlem' }"
            :paginationButtonColor="'red-600'"
            :paginationHoverColor="'red-700'"
            :containerClass="'p-2 bg-gray-50 dark:bg-gray-800 rounded shadow-sm'"
            :innerThClass="'py-2 text-left text-xxs font-medium bg-red-300 tracking-wider border-gray-200'"
            :innerTdClass="'whitespace-nowrap text-xxs bg-red-200 py-2'"
          >
          <template v-slot:searchBar> <SearchInput :value="search" :isFull="true" @searcing="(val) => {handleSearchValue(val); handleSearch();}" /> </template>
          <template v-slot:rowButtons="{ item, columnKey }">
          <div  v-if="columnKey === 'sensibility'">
            <p>{{ Money(item.sensibility) }} m</p>
          </div>
          </template>
            <template v-slot:batchOperations>
              <asyncBtn
                icon="fas fa-plus "
                :text="$t('operations.customers.newCustomer')"
                class="w-36 btn"
                @click="() => $modal.show('add-customer-modal')"
              />
            </template>
            <template v-slot:colButtons="{ item }">
              <div class="flex items-center justify-end space-x-2 px-2">
                <button class="mr-2" @click="showEditModal(item)">
                  <i class="fas fa-pen text-gray-700"></i>
                </button>
                <div class="relative kebab-dropdown">
                  <button @click="toggleMenu(item.id)" class="p-1 hover:bg-gray-100 rounded transition-colors">
                    <i class="fas fa-ellipsis-v text-gray-700"></i>
                  </button>
                  <div
                    v-if="openMenuId === item.id"
                    class="absolute right-0 mt-1 w-48 bg-white dark:bg-gray-700 rounded shadow-lg border border-gray-200 dark:border-gray-600 z-50"
                  >
                    <button
                      @click="showAddAccountModal(item)"
                      class="w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600 rounded-t flex items-center gap-2"
                    >
                      <i class="fas fa-user-plus text-green-600"></i>
                      Hesap Oluştur
                    </button>
                    <button
                      @click="showViewAccountsModal(item)"
                      class="w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600 flex items-center gap-2"
                    >
                      <i class="fas fa-users text-blue-600"></i>
                      Hesapları Görüntüle
                    </button>
                    <button
                      @click="openMenuId = null; deleteItem(item)"
                      class="w-full text-left px-4 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/30 rounded-b flex items-center gap-2"
                    >
                      <i class="fas fa-trash text-red-500"></i>
                      Müşteriyi Sil
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </LyrausTable>
        </div>
    </div>
  </div>
</template>

<script>
// Global Components
import asyncBtn from "@/components/general/asyncBtn.vue";
import SearchInput from "@/components/general/search-input.vue";
// Networking
import axios from "axios";
import { customer } from "../../../networking/urlmanager";

// Local Components
import addModal from "./components/add.modal.vue";
import editModal from "./components/edit.modal.vue";
import addAccountModal from "./components/addAccount.modal.vue";
import viewAccountsModal from "./components/viewAccounts.modal.vue";

export default {
  name: "customer-module",
  components: {
    asyncBtn,
    addModal,
    editModal,
    addAccountModal,
    viewAccountsModal,
    SearchInput
  },
  data() {
    return {
      load: false,
      search: "",
      selected: { id: "" },
      openMenuId: null,
      List: [],
      totalCount: 0,
      pageCount: 1,
      currentPage: 0,
      columns: [
        {
          key: "name",
          label: "Müşteri Adı",
        },
        {
          key: "priority",
          label: "Öncelik",
        },
        {
          key: "sensibility",
          label: "Hassasiyet (metre)",
          dontDisplay: true,
        },
      ],
    };
  },
  methods: {
    toggleMenu(itemId) {
      this.openMenuId = this.openMenuId === itemId ? null : itemId;
    },
    handleOutsideClick(e) {
      if (this.openMenuId !== null && !e.target.closest(".kebab-dropdown")) {
        this.openMenuId = null;
      }
    },
    showAddAccountModal(item) {
      this.openMenuId = null;
      this.selected = item;
      setTimeout(() => {
        this.$modal.show("add-customer-account-modal");
      }, 100);
    },
    showViewAccountsModal(item) {
      this.openMenuId = null;
      this.selected = item;
      setTimeout(() => {
        this.$modal.show("view-customer-accounts-modal");
      }, 100);
    },
    showEditModal(item) {
      this.selected = item;
      setTimeout(() => {
        this.$modal.show("edit-customer-modal");
      }, 100);
    },
    handleSearch() {
      this.clickSearch = false;
      this.searchColumn = "";
      this.currentPage = 0;
      this.getAll();
    },
    handleCurrentPage(val) {
      this.currentPage = val;
    },
    handleSearchValue(val) {
      this.search = val;
      this.getAll(true);
    },
    getAll(isSearch = false) {
      if (isSearch) this.currentPage = 0;
      this.List = [];
      this.load = true;
      axios
        .get(
          customer.getAll +
            "?page=" +
            this.currentPage +
            "&search=" +
            this.search,
          {
            headers: {
              Authorization: "Bareer " + this.$store.state.userData.token,
            },
          }
        )
        .then((res) => {
          this.List = res.data.data.detail;
          this.totalCount = res.data.data.totalCount;
          this.pageCount = res.data.data.pageCount;
        })
        .catch((err) => {
          this.errorBox(err.response);
        })
        .finally(() => {
          this.load = false;
        });
    },
    deleteItem(item) {
      this.swalBox(
        "warning",
        this.$t("general.warningTitle"),
        "Müşteriyi silmek istediğinize emin misiniz ?",
        true,
        this.$t("general.confirmText"),
        this.$t("general.rejectText")
      ).then((acc) => {
        if (acc.isConfirmed) {
          axios
            .post(
              customer.delete,
              {
                rowId: item.id.toString(),
                name: item.name,
              },

              {
                headers: {
                  Authorization: "Bareer " + this.$store.state.userData.token,
                },
              }
            )
            .then(() => {
              this.swalBox(
                "success",
                this.$t("general.successTitle"),
                "",
                false,
                this.$t("general.OkayTitle")
              );
              this.getAll();
            })
            .catch((err) => {
              this.errorBox(err.response);
            });
        }
      });
    },
  },
  created() {
    this.getAll();
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  watch: {
    currentPage() {
      this.getAll();
    },
  },
};
</script>
